<template>
  <div class="page-wrapper">
    <search-list  @findData="findData" :overReview="overReview" class="mb16"></search-list>

    <div >
      <Button type="primary" class="mb16" @click.stop="exportBalanceList" v-p="{api:'proprietor/exportBalanceList'}">导出</Button>
      <br>
      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading"
        :total="total"
        :current="current"
        @change-page="changePage"
      ></table-list>
    </div>
    <settle-ment :n="n" :balanceFid="balanceFid"
                 :balanceStatus="searched.balanceStatus"
                 v-if="searched"
                 @refresh="findData(searched)"
                 :control.async="control"
    ></settle-ment>
  </div>
</template>

<script>
  import TableList from "components/TableList/index";
  import SearchList from './components/SearchList'
  import {getBalanceList,releaseBalance,getBalanceOverview,canExportBalanceList,exportBalanceList} from "../../api/settleManage";
  import SettleMent from './components/SettleMent'
  import {validateAndDownload} from "../../utils/public";

  export default {
    name: "settlemanage",
    components:{
      SearchList,
      TableList,
      SettleMent
    },

    data(){
      return {
        control:{
          isRead:false
        },
        buttonloading:false,
        n:0,
        // scene:'chakan',
        balanceFid:'',
        data:[],
        loading:false,
        total:0,
        current:1,
        searched:null,
        page:1,
        overReview:[]


      }
    },
    computed:{
      columns(){
        if(!this.searched){
          return []
        }
        let ret=[]
        if(this.searched.balanceStatus===0 || this.searched.balanceStatus===1){
          ret=[
            {
              type: "index",
              key: "index",
              width: 60,
              align: "center"
            },


            {
              title: "项目",
              key: "projectName",
              align: "center",
            },
            {
              title: "业主",
              key: "proprietorName",
              align: "center",
            },
            {
              title: "结算单号",
              key: "balanceCode",
              align: "center",
              render:(h,params)=>{
                return h('a',{
                  on:{
                    click:()=>{
                      this.balanceFid=params.row['balanceFid']
                      this.control.isRead=true
                      this.n++
                    }
                  }

                },params.row['balanceCode'])
              }

            },
            // {
            //   title:' '
            // },

            {
              title: "结算金额",
              key: "paymentMoney",
              align: "center",
              width:150,
              render:(h,params)=>{
                return h('div',{
                  style:{
                    width:'100px',
                    textAlign:'right'
                  }


                },params.row['paymentMoney'])

               },
            },
            // {
            //   title:' '
            // },
            {
              title: "账期类型",
              key: "balancePeriodTypeName",
              align: "center",
            },
            {
              title: "结算周期",
              key: "balancePeriod",
              align: "center",
            },
            {
              title:'创建时间',
              key:'createTime',
              align:'center'
            },
            {
              title: "操作",
              key: "action",
              align: "center",
              render:(h,params)=>{
                return h('a',{
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'proprietor/passBalance'
                      }
                    }
                  ],
                  on:{
                    click:()=>{
                      this.balanceFid=params.row['balanceFid']
                      this.n++
                    }
                  }

                },this.searched.balanceStatus===0 ?'确认':'审核')

              }
            },
          ]

        }

        if(this.searched.balanceStatus===2 ||this.searched.balanceStatus===3 ){
          ret=[
            {
              type: "index",
              key: "index",
              width: 60,
              align: "center"
            },
            {
              title: "项目",
              key: "projectName",
              align: "center",
            },
            {
              title: "业主",
              key: "proprietorName",
              align: "center",
            },
            {
              title: "结算单号",
              key: "balanceCode",
              align: "center",
              render:(h,params)=>{
                return h('a',{
                  on:{
                    click:()=>{
                      this.balanceFid=params.row['balanceFid']
                      this.control.isRead=true
                      this.n++
                    }
                  }

                },params.row['balanceCode'])
              }

            },
            {
              title: "付款单号" ,
              key: "paymentCode",
              align: "center",

            },
            {
              title: "结算金额",
              key: "paymentMoney",
              align: "center",
              width:150,
              render:(h,params)=>{
                return h('div',{
                  style:{
                    width:'100px',
                    textAlign:'right'
                  }


                },params.row['paymentMoney'])

              },
            },
            {
              title: "付款状态",
              key: "paymentStatus",
              align: "center",
              render:(h,params)=>{
                let map={
                  '1':'未付款','2':'已付款','3':'付款异常','4':'付款中'
                }
                return h('span',{},map[params.row['paymentStatus']+''])
              }
            },
            {
              title: "账期类型",
              key: "balancePeriodTypeName",
              align: "center",
            },
            {
              title: "结算周期",
              key: "balancePeriod",
              align: "center",
            },
            {
              title:'创建时间',
              key:'createTime',
              align:'center'
            },
            {
              title: "操作",
              key: "action",
              align: "center",
              render:(h,params)=>{
                if(this.searched.balanceStatus===2 && params.row['paymentStatus']==3){
                  return h('a',{
                    directives:[
                      {
                        name:'p',
                        value:{
                          api:'proprietor/repay'
                        }
                      }
                    ],
                    on:{
                      click:()=>{
                        this.balanceFid=params.row['balanceFid']
                        this.n++

                      }
                    }
                  },'处理')

                }
                else {
                  return ''

                }
              }
            },

          ]

        }
        if(this.searched.balanceStatus===4){
          ret=[
            {
              type: "index",
              key: "index",
              width: 60,
              align: "center"
            },
            {
              title: "项目",
              key: "projectName",
              align: "center",
            },
            {
              title: "业主",
              key: "proprietorName",
              align: "center",
            },
            {
              title: "结算单号",
              key: "balanceCode",
              align: "center",
              render:(h,params)=>{
                return h('a',{
                  on:{
                    click:()=>{
                      this.balanceFid=params.row['balanceFid']
                      this.control.isRead=true
                      this.n++
                    }
                  }

                },params.row['balanceCode'])
              }

            },
            {
              title: "结算金额",
              key: "paymentMoney",
              align: "center",
              width:150,
              render:(h,params)=>{
                return h('div',{
                  style:{
                    width:'100px',
                    textAlign:'right'
                  }

                },params.row['paymentMoney'])

              },
            },
            {
              title: "账期类型",
              key: "balancePeriodTypeName",
              align: "center",
            },
            {
              title: "结算周期",
              key: "balancePeriod",
              align: "center",
            },
            {
              title: "驳回时间",
              key: "rejectTime",
              align: "center",
            },
            {
              title: "驳回人" ,
              key: "rejectPerson",
              align: "center",
            },
            {
              title:'创建时间',
              key:'createTime',
              align:'center'
            },
            {
              title: "操作",
              key: "action",
              align: "center",
              render:(h,params)=>{
                return h('div',{},
                  [
                    h('a',{
                      style:{marginRight:'15px'},
                      on:{
                        click:()=>{
                          this.$Modal.info({
                            title: '驳回原因',
                            content: params.row['rejectContent'] || '无'
                          });
                        }
                      }

                    },'驳回原因'),
                    h('a',{
                      directives:[
                        {
                          name:'p',
                          value:{
                            api:'proprietor/releaseBalance'
                          }
                        }
                      ],
                      on:{
                        click:()=>{
                          this.$Modal.confirm({
                            title: '结算单释放',
                            content: '<p>继续操作该结算单将被释放，需要业主重新确认提交。请问是否继续？</p>',
                            onOk: () => {
                              releaseBalance({balanceFid: params.row['balanceFid']}).then(res => {
                                this.$Message.success('操作成功')
                              }).catch(error => {

                              }).finally(() => {
                                this.findData(this.searched)
                              })
                              // this.dataList.splice(index, 1)
                            }
                          })
                        }

                      }
                    },'释放')
                  ]
                )

              }
            },


          ]

        }
        return ret
      }

    },

    methods:{
      exportBalanceList() {
        if (this.total === 0) {
          this.$Message.info('数据列表为空！')
          return
        }
        this.buttonloading = true

        validateAndDownload(null,exportBalanceList,this.searched).catch(error=>{}).finally(()=>{
          this.buttonloading = true
        })
      },
      getBalanceOverview(){
        let params={
          projectFid:this.searched.projectFid
        }
        getBalanceOverview(params).then(res=>{
          res.data && (this.overReview=res.data)

        }).catch(error=>{

        })

      },
      getBalanceList(data){
        let params={
          ...data,
          page:this.page,
          limit:10

        }
        getBalanceList(params).then(res=>{

          this.searched=data
          if(!res.data){
            return
          }
          res.data.rows && ( this.data=res.data.rows )
          this.total=res.data.total
          this.getBalanceOverview()
        }).catch(error=>{})


      },
      findData(data){
        this.page=1
        this.current=1
        this.getBalanceList(data)
      },
      changePage(n){
        this.page=n
        this.current=n
        this.getBalanceList(this.searched)
      }
    }

  }
</script>

<style scoped>

</style>
